// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"166464b2","513":"59db971f","703":"51b8b1c0","787":"84fa5073"}[chunkId] + ".chunk.js";
};